<svelte:head>
	<link href="https://fonts.googleapis.com/css2?family=Anton&family=Dancing+Script&family=Dosis&family=Notable&family=Pangolin&family=Lobster&family=Montserrat:wght@700&family=Pacifico&family=Roboto+Slab:wght@100&family=Roboto:wght@100&display=swap" rel="stylesheet">
</svelte:head>  
<script>
     import ImgEncoder from 'svelte-image-encoder';
     import Botoes from "./botao.svelte";
     import Microsite from  "./microsite.svelte";
	 import Rodape from  "./rodape.svelte";
	 import Acordeon from "./arcodeon.svelte";
	 import md5 from 'crypto-js/md5';
	 import Avancado from "./detalheAvancado.svelte";
	
	 import {onMount, createEventDispatcher} from "svelte";
     const dispatch = createEventDispatcher();
      import { Nav, NavItem, Dropdown, DropdownItem, DropdownToggle, DropdownMenu, NavLink } from 'sveltestrap';

	 export let name="";
	 export let edit=false;
	 export let id_unico="";
	 export let login="";
	 export let tipoUsuario="";
	 let listaUsuarios=[];
	 $:tipoUsuario=tipoUsuario.toUpperCase();
	 let limite= 800;
	 let linkAleatorio="";
	 let link="";
	 let linkBtn="";
	 let botao=""; 
	 let logo; 
	 let logo2=[]; 
	 let sombraLogo1=0;
	 let sombraLogo2=0;
	 let sombraLogo3=0;
	 let sombraLogo4=0;
	 let sombra1=0;
	 let sombra2=0;
	 let sombra3=0;
	 let sombra4=0;
	 let corSombra="#ffffff";
	 let sombraDescricao1=0;
	 let sombraDescricao2=0;
	 let sombraDescricao3=0;
	 let sombraDescricao4=0;
	 let sombraAreaBotao1=0;
	 let sombraAreaBotao2=0;
	 let sombraAreaBotao3=0;
	 let sombraAreaBotao4=0;
	 let corSombraAreaBotao="#000000";
	 let sombraBotao1=0;
	 let sombraBotao2=0;
	 let sombraBotao3=0;
	 let sombraBotao4=0;
	 let corSombraBotao="#000000";
	 let espacamentoDescricaoInferior=0;
	 let espacamentoAreaBotaoInferior=0;
	 let espacamentoAreaBotaoSuperior=0;
	 let espacamentoBotaoSuperior=0;
	 let espacamentoBotaoInferior=0;
	 let espacamentoSuperior=0;
	 let espacamentoInferior=0;
	 let espacamentoDescricaoSuperior=0;
	 let corSombraDescricao="#ffffff";
     let textoRodape="";
	 let corSombraLogo='#ffffff';
	 let fonteDescricao="";
	 let fonteBotao="";
	 let tamanhoLetraDescricao=20;
	 let tamanhoLetraBotao=20;
     
     


	 let descricao="Escreva algo aqui"; 
	 let larguraMaximaLogo="300"; 
	 $:larguraMaximaLogoAplicada=larguraMaximaLogo+"px";
	 let corDescricao="#ffffff"; 
	 let corLetraDescricao="#000000"; 
	 let corBotao="#D1D1D1"; 
	 let corLetraBotao="#ffffff"; 
	 let bot;
	 let newInnerHTML;
	 let ListaBotoes=[];
     let vazio=false;
     let corCabecalho="#ffffff"; 
	 let corLetraCabecalho="#000000"; 
	 let corAreaBotao="#ffffff"; 
	 let corLetraRodape="#000000"; 
	 let corRodape="#ffffff"; 
	 let url;
	 let quality=0.1;
	 let realTime=true;
	 let linkPersonalizado="";
	 let linkPersonalizadoRetorno="";
	 let habilitaSalvar=false;
	 let quantidadeBotoes=0;
	 let tipoLink="link";
	 let innerWidth="";
	 let innerHeight="link";
	 let paginaProcessamento="http://microsites.en-curta.me/svelte/processa.php";
	 
	 let EditObjs = [];
	 $:innerHeight=0;
	 $:innerWidth=0;
	 $:descricaoBR = descricao.replace(/\r?\n/g, '<br />');
	 $:if(edit){paginaProcessamento="http://microsites.en-curta.me/svelte/processaEdicao.php";}
	    var Base64={_keyStr:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",encode:function(e){var t="";var n,r,i,s,o,u,a;var f=0;e=Base64._utf8_encode(e);while(f<e.length){n=e.charCodeAt(f++);r=e.charCodeAt(f++);i=e.charCodeAt(f++);s=n>>2;o=(n&3)<<4|r>>4;u=(r&15)<<2|i>>6;a=i&63;if(isNaN(r)){u=a=64}else if(isNaN(i)){a=64}t=t+this._keyStr.charAt(s)+this._keyStr.charAt(o)+this._keyStr.charAt(u)+this._keyStr.charAt(a)}return t},decode:function(e){var t="";var n,r,i;var s,o,u,a;var f=0;e=e.replace(/[^A-Za-z0-9\+\/\=]/g,"");while(f<e.length){s=this._keyStr.indexOf(e.charAt(f++));o=this._keyStr.indexOf(e.charAt(f++));u=this._keyStr.indexOf(e.charAt(f++));a=this._keyStr.indexOf(e.charAt(f++));n=s<<2|o>>4;r=(o&15)<<4|u>>2;i=(u&3)<<6|a;t=t+String.fromCharCode(n);if(u!=64){t=t+String.fromCharCode(r)}if(a!=64){t=t+String.fromCharCode(i)}}t=Base64._utf8_decode(t);return t},_utf8_encode:function(e){e=e.replace(/\r\n/g,"\n");var t="";for(var n=0;n<e.length;n++){var r=e.charCodeAt(n);if(r<128){t+=String.fromCharCode(r)}else if(r>127&&r<2048){t+=String.fromCharCode(r>>6|192);t+=String.fromCharCode(r&63|128)}else{t+=String.fromCharCode(r>>12|224);t+=String.fromCharCode(r>>6&63|128);t+=String.fromCharCode(r&63|128)}}return t},_utf8_decode:function(e){var t="";var n=0;var r=c1=c2=0;while(n<e.length){r=e.charCodeAt(n);if(r<128){t+=String.fromCharCode(r);n++}else if(r>191&&r<224){c2=e.charCodeAt(n+1);t+=String.fromCharCode((r&31)<<6|c2&63);n+=2}else{c2=e.charCodeAt(n+1);c3=e.charCodeAt(n+2);t+=String.fromCharCode((r&15)<<12|(c2&63)<<6|c3&63);n+=3}}return t}}

	 onMount(()=>{
		 if(edit==true)
		 {
			 BuscaEdicao();
		 }

		 if(tipoUsuario!="PRO" && tipoUsuario!="PLUS" && tipoUsuario!="MASTER"){
			 BuscarLinkAleatorio();
		 }
		  if(tipoUsuario.toUpperCase()=="MASTER"){
			   console.log("aqui master");
				ListarUsuarios();
			}

	 });
	 function utf8_to_str(a) {
    for(var i=0, s=''; i<a.length; i++) {
        var h = a[i].toString(16)
        if(h.length < 2) h = '0' + h
        s += '%' + h
    }
    return decodeURIComponent(s)
}
function ListarUsuarios(){
 
  
     console.log('aqui');
     
  var data = new FormData();
  data.append("tipo_usuario", tipoUsuario);
  
	fetch('http://microsites.en-curta.me/svelte/usuarios.php', {
  method: 'POST', // or 'PUT'
  /*header:  {//'Content-type': 'text/html'
 'Content-type': 'application/x-www-form-urlencoded'
 
 },*/
  body: data,
})

.then(data => {
  data.text().then(text=> {
    let lista = text.split("|")
    for (var i in lista){
      listaUsuarios=[...listaUsuarios, JSON.parse(lista[i]).email_acesso]
    }
    //console.log("lista usuario"+listaUsuarios);
  }) 
  
})
.catch((error) => {
  console.error('Error:', error);
  
});
} 
function utf8_from_str(s) {
    for(var i=0, enc = encodeURIComponent(s), a = []; i < enc.length;) {
        if(enc[i] === '%') {
            a.push(parseInt(enc.substr(i+1, 2), 16))
            i += 3
        } else {
            a.push(enc.charCodeAt(i++))
        }
    }
    return a
}
var decodeBase64 = function(s) {
    var e={},i,b=0,c,x,l=0,a,r='',w=String.fromCharCode,L=s.length;
    var A="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    for(i=0;i<64;i++){e[A.charAt(i)]=i;}
    for(x=0;x<L;x++){
        c=e[s.charAt(x)];b=(b<<6)+c;l+=6;
        while(l>=8){((a=(b>>>(l-=8))&0xff)||(x<(L-2)))&&(r+=w(a));}
    }
    return r;
};
function b64DecodeUnicode(str) {
    // Going backwards: from bytestream, to percent-encoding, to original string.
    return decodeURIComponent(atob(str).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
}
function b64_to_utf8( str ) {
  return decodeURIComponent(escape(window.atob( str )));
}
     function BuscaEdicao(){
	
 
     console.log('aqui');
     
  var data = new FormData();
  data.append("id_unico", id_unico);
  
	fetch('http://microsites.en-curta.me/svelte/edicao.php', {
  method: 'POST', // or 'PUT' 
  /*header:  {//'Content-type': 'text/html'
 'Content-type': 'application/x-www-form-urlencoded'
 
 },*/
  body: data,
})

.then(data => {
  data.text().then(text=> {
 // console.log("retorno"+text);
  let links =text.split("|");
 // console.log(links);
  EditObjs=[];
  for (let i in links){
     // console.log(links[i]);
        let obj = JSON.parse(links[i]);
		//console.log(obj.link_resultado);
	    linkPersonalizado=(obj.link_resultado);
	    linkPersonalizadoRetorno=(obj.link_resultado);
	    descricao=b64DecodeUnicode(obj.descricao);
	    corCabecalho=b64DecodeUnicode(obj.corCabecalho);
	    corDescricao=b64DecodeUnicode(obj.corDescricao);
		corLetraDescricao=b64DecodeUnicode(obj.corLetraDescricao);
	//	console.log(corLetraDescricao);
	//	console.log(corDescricao);
	    corAreaBotao=b64DecodeUnicode(obj.corAreaBotao);
	    corBotao=b64DecodeUnicode(obj.corBotao);
	    corLetraBotao=b64DecodeUnicode(obj.corLetraBotao); 
	    corRodape=b64DecodeUnicode(obj.corAreaRodape);
		corLetraRodape=b64DecodeUnicode(obj.corLetraRodape);
		//pro
		larguraMaximaLogo = obj.largura_maxima_logo;

		if(larguraMaximaLogo==0){
			larguraMaximaLogo=300;
		}
		sombraLogo1= obj.sombra_logo_1;
		sombraLogo2= obj.sombra_logo_2;
		sombraLogo3= obj.sombra_logo_3;
		sombraLogo4= obj.sombra_logo_4;
		corSombraLogo = b64DecodeUnicode(obj.cor_sombra_logo);
		sombraDescricao1=obj.sombra_descricao_1;
		sombraDescricao2=obj.sombra_descricao_2;
		sombraDescricao3=obj.sombra_descricao_3;
		sombraDescricao4=obj.sombra_descricao_4;
		corSombraDescricao=b64DecodeUnicode(obj.cor_sombra_descricao);
		espacamentoDescricaoSuperior=obj.espacamento_descricao_superior;
		espacamentoDescricaoInferior=obj.espacamento_descricao_inferior;

		espacamentoAreaBotaoSuperior=obj.espacamento_area_botao_superior;
		espacamentoAreaBotaoInferior=obj.espacamento_area_botao_inferior;
		espacamentoBotaoSuperior=obj.espacamento_botao;
        sombraAreaBotao1=obj.sombra_area_botao_1;
        sombraAreaBotao2=obj.sombra_area_botao_2;
        sombraAreaBotao3=obj.sombra_area_botao_3;
		sombraAreaBotao4=obj.sombra_area_botao_4;
		
		corSombraAreaBotao=b64DecodeUnicode(obj.cor_sombra_area_botao);
		fonteDescricao=b64DecodeUnicode(obj.fonte_descricao);;
		fonteBotao=b64DecodeUnicode(obj.fonte_botao);
		tamanhoLetraDescricao=obj.tamanho_letra_descricao;
		tamanhoLetraBotao=obj.tamanho_letra_botao;
		if(tamanhoLetraDescricao==0){
			tamanhoLetraDescricao=20;
		}
		if(tamanhoLetraBotao==0){
			tamanhoLetraBotao=20;
		}
        textoRodape=b64DecodeUnicode(obj.texto_rodape);
        sombraBotao1=obj.sombra_botao_1;
        sombraBotao2=obj.sombra_botao_2;
        sombraBotao3=obj.sombra_botao_3;
		sombraBotao4=obj.sombra_botao_4;
		corSombraBotao=b64DecodeUnicode(obj.cor_sombra_botao);
	    ListaBotoes = [...ListaBotoes, {id:Math.random(), itemIdBotao:obj.id_botao, itemLink:b64DecodeUnicode(obj.link), itemBotao:b64DecodeUnicode((obj.botao)),
		itemCorBotao:b64DecodeUnicode(obj.corBotao), 
		itemCorLetraBotao:b64DecodeUnicode(obj.corLetraBotao)
		
		
		}];
		url=obj.logo_s3;
		logo=obj.logo_s3;
		console.log("logo"+url);
		
	    
        EditObjs=[...EditObjs, obj]
  
  }
  quantidadeBotoes=ListaBotoes.length;
  console.log(ListaBotoes);
  
  }
  ); 
  
})
.catch((error) => {
  console.error('Error:', error);
 
});
}
	 function fazerBotao(tipo) {
		// newInnerHTML = '<Botoes link={link}/>';
		// bot.innerHTML += newInnerHTML;
		vazio=false;
		if(botao.trim()==""|| link.trim()==""){
			vazio=true;
			return;
		}
		switch (tipoLink){
			case 'link':
				console.log("tipo link");
				linkBtn=link;
			if(!linkBtn.includes("http://") && !(linkBtn.includes("https://")))
					{ 
						linkBtn="http://"+linkBtn;
					}
			break;
			case 'telefone':
			
			 var regex = /[^0-9]/;
			if(regex.test(link)){
				alert("Formato inválido!");
				return;
			}
			linkBtn=link;
			if(!link.includes("tel:"))
			{ 
						linkBtn="tel:"+linkBtn;
		    }
			break;
			case 'email':
			const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if(!re.test(String(link).toLowerCase())){

				alert("Formato inválido!");
				return;
			}
			linkBtn=link;
			if(!link.includes("mailto:"))
					{ 
						linkBtn="mailto:"+linkBtn;
					}
			break;
			case 'whatsapp':
			  
			 var regex = /[^0-9]/;
			if(regex.test(link)){
				alert("Formato inválido!");
				return;
			}
			linkBtn="https://api.whatsapp.com/send?phone=55"+link;			
			break;
			case 'insta':
			var regex = /@\w+/; 
			if(!regex.test(link)){
				alert("Formato inválido!");
				return;
			}
			linkBtn="https://www.instagram.com/"+link.replace("@","");
			
			break;
			case 'maps':
			var regex = /[^0-9,.-]/; 
			if(regex.test(link)){
				alert("Formato inválido!");
				return;
			}
			linkBtn="https://www.google.com/maps/place/"+link;
			
			break;
			case 'uber':
			var regex = /[^0-9,.-]/; 
			if(regex.test(link)){
				alert("Formato inválido!");
				return;
			}
			linkBtn="https://m.uber.com/ul/?action=setPickup&client_id=AyzKpGqhVjmKaztygcE8akXblzTxdh0G&pickup=my_location&dropoff[formatted_address]="+link.replace(",","%2C");
			
			break;
			default:
				linkBtn=link;
				break;
		}
			
		
		if(tipo==0){
			ListaBotoes = [...ListaBotoes, {id:Math.random(), itemIdBotao:"", itemLink:linkBtn, itemBotao:botao,
		itemCorBotao:corBotao, itemCorLetraBotao:corLetraBotao}];
		quantidadeBotoes=ListaBotoes.length;
		}else{
        ListaBotoes = [ {id:Math.random(), itemIdBotao:"", itemLink:linkBtn, itemBotao:botao,
		itemCorBotao:corBotao, itemCorLetraBotao:corLetraBotao},...ListaBotoes];
		quantidadeBotoes=ListaBotoes.length; 

		}		

	}
    function loadFile(e) {
		url = URL.createObjectURL(e.target.files[0]);
	}
	function ApagarUltimo()
	{
        ListaBotoes=ListaBotoes.slice(0,-1);


	}
	function ApagarPrimeiro()
	{
        ListaBotoes=ListaBotoes.slice(1);


	}
   
     function teste(){

     

		 var HttpClient = function() {
    this.get = function(aUrl, aCallback) {
        var anHttpRequest = new XMLHttpRequest();
        anHttpRequest.onreadystatechange = function() { 
            if (anHttpRequest.readyState == 4 && anHttpRequest.status == 200)
                aCallback(anHttpRequest.responseText);
        }

        anHttpRequest.open( "GET", aUrl, true );            
        anHttpRequest.send( null );
    }
}
		 console.log("teste2");
		var client = new HttpClient();
	 let continua=false;	
	 if(edit){
		 if(linkPersonalizado===linkPersonalizadoRetorno){
			 habilitaSalvar=true;
			 console.log("retornando");
			 return;
		 }
	 }
	 client.get('http://microsites.en-curta.me/criar_micro_site/checanome.php?conteudo='+Base64.encode("_"+linkPersonalizado), function(response) {
	
	habilitaSalvar=false;
	 console.log(response);
	 console.log(linkPersonalizado);
	if(response==1){
		habilitaSalvar=true;
	}
});
	 }
	 let isOpen=false;
	 let tgs = [false, false];

	
    function AbreAcord(numero, e){
		e.preventDefault();
		if(tgs[numero]){
			isOpen=false;
			for(var i=0; i<tgs.length; i++){
				tgs[i]=false;
				console.log("i"+tgs[i]);
			}
			return;
		}else{
 			isOpen=true;
		}
		
		for(var i=0; i<tgs.length; i++){
			tgs[i]=false;
			console.log("i"+tgs[i]);
		}
		tgs[numero]=true;
		console.log(tgs);
		console.log(tgs[numero]);
	}
 import { Button, Jumbotron, Collapse,ButtonToolbar, CardBody, Card} from 'sveltestrap';



function ChamarTela(e){
	console.log("chamandotela")
	dispatch("ChamarTela",e);
}
function BuscarLinkAleatorio(){
     console.log(Math.random()*32);
	let num = md5(Math.random()*32+" ")+"";
	linkAleatorio=num.substring(0,14);

	if(ChecaLink(linkAleatorio)==0){
		BuscarLinkAleatorio();

	}
	habilitaSalvar=true;
}
function ChecaLink(link){

  var data = new FormData();
  data.append("conteudo", link);

	fetch('http://microsites.en-curta.me/criar_micro_site/checanome.php', {
  method: 'POST', // or 'PUT'
  /*header:  {//'Content-type': 'text/html'
 'Content-type': 'application/x-www-form-urlencoded'
 
 },*/
  body: data,
})

.then(data => {
  data.text().then(text=> {

	  console.log("checando link"+text)
  return text;
  
 
 
  
  
  }) 
  
})
.catch((error) => {
  console.error('Error:', error);
  return "erro";
});
} 
function  EditaBotao(botao,i) {
	botao.preventDefault();
	ListaBotoes[i] = botao.detail;

	console.log("mudou lista"+botao);

}
function  ApagarBotao(e,i) {
	e.preventDefault();
	if(ListaBotoes.length>1){
			ListaBotoes = [...ListaBotoes.slice(0, i), ...ListaBotoes.slice(i + 1)];
	}else{
		ListaBotoes=[];
	}
	
	console.log("apagou");
	

}
function  SobeBotao(e,i) {
	e.preventDefault();
	if(i==0 && ListaBotoes.length>1){
			let temp = ListaBotoes[ListaBotoes.length-1];
			let temp2 = ListaBotoes[i];
			ListaBotoes[ListaBotoes.length-1]=temp2;
			ListaBotoes[i]=temp;
	}else if (ListaBotoes.length>1){
		    
		    let temp = ListaBotoes[i-1];
			let temp2 = ListaBotoes[i];
			ListaBotoes[i-1]=temp2;
			ListaBotoes[i]=temp;
	}
	
	console.log("posicao "+i);
	

}
function  DesceBotao(e,i) {
	e.preventDefault();
	if(i==ListaBotoes.length-1 && ListaBotoes.length>1 ){
			let temp = ListaBotoes[0];
			let temp2 = ListaBotoes[i];
			ListaBotoes[0]=temp2;
			ListaBotoes[i]=temp;
	}else if (ListaBotoes.length>1 && i<ListaBotoes.length-1){
		    
		    let temp = ListaBotoes[i+1];
			let temp2 = ListaBotoes[i];
			ListaBotoes[i+1]=temp2;
			ListaBotoes[i]=temp;
	}
	console.log("posicao "+i);

}
</script>
<svelte:window bind:innerWidth bind:innerHeight></svelte:window>
<Nav>
  <NavLink on:click={(e)=>ChamarTela("painelposlogin")}>Voltar painel do cliente</NavLink>
  
</Nav>
<main>

	
    
	<form  method="POST" action="{paginaProcessamento}" enctype="multipart/form-data">
      <div class="container">
        <div class="row">
          <div class="col-12 text-center">
		    {#if tipoUsuario.toUpperCase()=="MASTER"}
			Selecionar o usuário
				<select class="form-control" bind:value={login}>
				
				
		  
				{#each listaUsuarios as usuario }
                     <option  value="{usuario}"   >{usuario}</option> 
				{/each}
				</select>

			{/if}

			
            <h2>Configurando aparência</h2>
          </div>
        </div>
      </div>
      <div class="container ">
        <div class="row">
           <div class="col-12 text-center"><label class="form-control">Escolher uma logo</label>
		   	<input class="form-control" type="file"  id="logo" name="logo" on:change={loadFile} bind:value={logo2} />
			  <p></p>
        <section>
	{#if innerWidth>limite && innerWidth>innerHeight}
	<div class="row  text-center ">
	<div class="col-12">
	<h3 class="mt-3">Selecione as áreas para edição clicando nos botões</h3>
 <Button   color="secondary" size="sm" on:click ={(e)=>AbreAcord(0, e)} class="my-4 mx-1 col-2 ">Área do cabeçalho</Button>
  <Button   color="success" size="sm" on:click ={(e)=>AbreAcord(1, e)} class="my-4 mx-1 col-2" >Área da descrição</Button>
  <Button   color="warning" size="sm" on:click ={(e)=>AbreAcord(2, e)} class="my-4 mx-1 col-2 ">Área dos botões</Button>
  <Button   color="danger" size="sm" on:click ={(e)=>AbreAcord(3, e)} class="my-4 mx-1 col-2 ">Área do rodapé</Button>

	
	</div>

	</div>
	{/if} 
	
{#if innerWidth<innerHeight || innerWidth<=limite}
<h5 class="my-3">Selecione as áreas para edição clicando nos botões</h5>
		   <Button   color="secondary" size="block" on:click ={(e)=>AbreAcord(0, e)} class="mb-3">Área do cabeçalho</Button>
{/if}

{#if tgs[0]}
<Collapse {isOpen}> <h3>Cabeçalho</h3>
<Jumbotron>
            <p>Escolha  as cores do cabeçalho</p>
		
			<label class="form-control" for="corCabecalho">Cor do cabeçalho</label>
			  
	        <input class="form-control" type="color" id="corCabecalho" bind:value={corCabecalho} /><p></p>
	      	
			{#if tipoUsuario!="PRO" && tipoUsuario!="MASTER"}
			<p>Apenas PRO</p>  
			<label class="mt-2" for="larguraLogo">Largura máxima da logo (até o limite da largura original)</label>
		
	        <input class="form-control" type="range" id="larguraLogo"  disabled max="1000" bind:value={larguraMaximaLogo} />{larguraMaximaLogo}px
	        <p>
			<label class="mt-2" for="sombraLogo1">Sombreamento da logo </label>
			</p>
		 
			<div class="row">
				<div class="col-lg-2 col-12">
				<label for="sombraLogo1">Offset x</label>
					<input class="form-control" type="range" id="sombraLogo1" disabled  min="-50" step="0.01" max="500" bind:value={sombraLogo1} />{sombraLogo1}px
			
				
				</div>
				<div class="col-lg-2 col-12">
				<label for="sombraLogo1">Offset y</label>
					<input class="form-control" type="range" id="sombraLogo2" disabled min="-50"  step="0.01" max="500" bind:value={sombraLogo2} />{sombraLogo2}px
			
				</div>
				<div class="col-lg-2 col-12">
				<label for="sombraLogo1">Blur</label>
					<input class="form-control" type="range" id="sombraLogo3" disabled step="0.01" max="500" bind:value={sombraLogo3} />{sombraLogo3}px
		
				</div>
				<div class="col-lg-2 col-12">
				<label for="sombraLogo1">Spread</label>
					<input class="form-control" type="range" id="sombraLogo3" disabled step="0.01" max="500" bind:value={sombraLogo4} />{sombraLogo4}px
		
				</div>
				<div class="col-lg-2 col-12">
				<label for="sombraLogo1">Cor</label>
					<input class="form-control" type="color" id="corSombraLogo"  disabled  bind:value={corSombraLogo} />{corSombraLogo}			
				</div>
		
			</div>
	     	

			{:else}

			 <p>Apenas PRO</p>  
			<label class="mt-2" for="larguraLogo">Largura máxima da logo (até o limite da largura original)</label>
		
	        <input class="form-control" type="range" id="larguraLogo"  max="1000" bind:value={larguraMaximaLogo} />{larguraMaximaLogo}px
	        <p>
			<label class="mt-2" for="sombraLogo1">Sombreamento da logo </label>
			</p>
		 
			<div class="row">
				<div class="col-lg-2 col-12">
				<label for="sombraLogo1">Offset x</label>
					<input class="form-control" type="range" id="sombraLogo1"   min="-50" step="0.01" max="500" bind:value={sombraLogo1} />{sombraLogo1}px
			
				
				</div>
				<div class="col-lg-2 col-12">
				<label for="sombraLogo1">Offset y</label>
					<input class="form-control" type="range" id="sombraLogo2"  min="-50"  step="0.01" max="500" bind:value={sombraLogo2} />{sombraLogo2}px
			
				</div>
				<div class="col-lg-2 col-12">
				<label for="sombraLogo1">Blur</label>
					<input class="form-control" type="range" id="sombraLogo3"  step="0.01" max="500" bind:value={sombraLogo3} />{sombraLogo3}px
		
				</div>
				<div class="col-lg-2 col-12">
				<label for="sombraLogo1">Spread</label>
					<input class="form-control" type="range" id="sombraLogo3" step="0.01" max="500" bind:value={sombraLogo4} />{sombraLogo4}px
		
				</div>
				<div class="col-lg-2 col-12">
				<label for="sombraLogo1">Cor</label>
					<input class="form-control" type="color" id="corSombraLogo"    bind:value={corSombraLogo} />{corSombraLogo}			
				</div>
		
			</div>
			
			{/if}
			
			</Jumbotron></Collapse>
{/if}



          </div>
          <div class="col-12 text-center">
		  {#if innerWidth<innerHeight || innerWidth<=limite}
            <Button   color="success"  size="block"  on:click ={(e)=>AbreAcord(1,e)} class="mb-3"> Área da descricao</Button>
{/if}

{#if tgs[1]}
<Collapse {isOpen}> <Jumbotron class="border border-success">
            <h3>Área da descrição</h3>
            <p>Escolha uma descrição e cores para região central do seu micro site.</p>
			  <label class=""  for="descricao">Escreva uma descrição</label>
			  <p></p>
			    <textarea class="form-control"  id="descricao" bind:value={descricao} ></textarea>
			  <p></p>
				<label class=""  for="corDescricao">Cor da área de descrição</label>
				<input class="form-control"  type="color" id="corDescricao"   bind:value={corDescricao}/>
				<p></p>
				<label class=""   for="corLetraDescricao">Cor da letra da descrição</label>
				<input class="form-control"  type="color" id="corLetraDescricao"   bind:value={corLetraDescricao}/><p></p>
        <!--		
		   {#if tipoUsuario=="PRO" || tipoUsuario=="MASTER"}
           <h5>Apenas PRO</h5>  
			<div class="row">
				<div class="col-lg-6 col-12">
						<label class="mt-2" for="espacamentoDescricaoSuperior">Espaçamento superior</label>
					
						<input class="form-control" type="range" id="espacamentoDescricaoSuperior"  max="900" bind:value={espacamentoDescricaoSuperior} />
						<input type="text" class="sm mt-2"  bind:value={espacamentoDescricaoSuperior}/>px
					
						<p>
						</div>
						<div class="col-lg-6 col-12">
						<label class="mt-2" for="espacamentoDescricaoInferior">Espaçamento inferior</label>
					
						<input class="form-control" type="range" id="espacamentoDescricaoInferior"  max="900" bind:value={espacamentoDescricaoInferior} />
						<input type="text" class="sm mt-2"  bind:value={espacamentoDescricaoInferior}/>px
						</div>
			<div class="col-12">
			<h5 class="mt-2" for="sombraDescricao1">Sombreamento da área de descrição    </h5> 
			<p></p>
			
			
			
			</div>
		 </div>
			<div class="row col-12 text-center">
				<div class="col-lg-2 col-12">
				<label for="sombraLogo1">Offset x</label>
					<input class="form-control" type="range" id="sombraDescricao1"   min="-50" step="0.01" max="500" bind:value={sombraDescricao1} />
					<input type="text" class="sm mt-2"  bind:value={sombraDescricao1}/>px
			
				
				</div>
				<div class="col-lg-2 col-sm-12">
				<label for="sombraLogo1">Offset y</label>
					<input class="form-control" type="range" id="sombraDescricao2"  min="-50"  step="0.01" max="500" bind:value={sombraDescricao2} />
					<input type="text" class="sm mt-2"  bind:value={sombraDescricao2}/>px
			
				</div>
				<div class="col-lg-2 col-sm-12">
				<label for="sombraLogo1">Blur</label>
					<input class="form-control" type="range" id="sombraDescricao3"  step="0.01" max="500" bind:value={sombraDescricao3} />
					<input type="text" class="sm mt-2"  bind:value={sombraDescricao3}/>px
		
				</div>
				<div class="col-lg-2 col-sm-12">
				<label for="sombraLogo1">Spread</label>
					<input class="form-control" type="range" id="sombraLogo3" step="0.01" max="500" bind:value={sombraDescricao4} />
				<input type="text" class="sm mt-2"  bind:value={sombraDescricao4}/>px
		
				</div>
				<div class="col-lg-2 col-sm-12">
				<label for="sombraLogo1">Cor</label>
					<input class="form-control" type="color" id="corSombraDescricao"    bind:value={corSombraDescricao} />{corSombraDescricao}			
				</div>
		
			</div>
			{:else}
  <h5>Apenas PRO</h5>  
  <div class="row">
  	<div class="col-lg-6 col-12">
			<label class="mt-2" for="espacamentoDescricaoSuperior">Espaçamento superior</label>
		
	        <input class="form-control" disabled type="range" id="espacamentoDescricaoSuperior"  max="900" bind:value={espacamentoDescricaoSuperior} />
			<input type="text" class="sm mt-2" disabled bind:value={espacamentoDescricaoSuperior}/>px
	      
		    <p>
			</div>
			<div class="col-lg-6 col-12">
			<label class="mt-2" for="espacamentoDescricaoInferior">Espaçamento inferior</label>
		
	        <input class="form-control" disabled type="range" id="espacamentoDescricaoInferior"  max="900" bind:value={espacamentoDescricaoInferior} />
			<input type="text" class="sm mt-2" disabled  bind:value={espacamentoDescricaoInferior}/>px
	        </div>
			<div class="col-12">
			<h5 class="mt-2" for="sombraDescricao1">Sombreamento da área de descrição    </h5> 
			<p></p>
			
			
			
			</div>
		 </div>
			<div class="row col-12 text-center">
				<div class="col-lg-2 col-12">
				<label for="sombraLogo1">Offset x</label>
					<input class="form-control" type="range" disabled id="sombraDescricao1"   min="-50" step="0.01" max="500" bind:value={sombraDescricao1} />
					<input type="text" disabled class="sm mt-2"  bind:value={sombraDescricao1}/>px
			
				
				</div>
				<div class="col-lg-2 col-sm-12">
				<label for="sombraLogo1">Offset y</label>
					<input class="form-control" type="range" disabled id="sombraDescricao2"  min="-50"  step="0.01" max="500" bind:value={sombraDescricao2} />
					<input type="text" class="sm mt-2" disabled  bind:value={sombraDescricao2}/>px
			
				</div>
				<div class="col-lg-2 col-sm-12">
				<label for="sombraLogo1">Blur</label>
					<input class="form-control" type="range" disabled id="sombraDescricao3"  step="0.01" max="500" bind:value={sombraDescricao3} />
					<input type="text" class="sm mt-2" disabled  bind:value={sombraDescricao3}/>px
		
				</div>
				<div class="col-lg-2 col-sm-12">
				<label for="sombraLogo1">Spread</label>
					<input class="form-control" type="range" disabled id="sombraLogo3" step="0.01" max="500" bind:value={sombraDescricao4} />
				<input type="text" class="sm mt-2" disabled bind:value={sombraDescricao4}/>px
		
				</div>
				<div class="col-lg-2 col-sm-12">
				<label for="sombraLogo1">Cor</label>
					<input class="form-control" disabled type="color" id="corSombraDescricao"    bind:value={corSombraDescricao} />{corSombraDescricao}			
				</div>
		
			</div>
			{/if}-->
              <Avancado {tipoUsuario} ExibirFonte=true bind:fonte={fonteDescricao} bind:sombra1={sombraDescricao1}
					bind:sombra2={sombraDescricao2}
					bind:sombra3={sombraDescricao3}
					bind:sombra4={sombraDescricao4}
					bind:corSombra={corSombraDescricao}
					bind:tamanhoLetra={tamanhoLetraDescricao}
					bind:espacamentoSuperior={espacamentoDescricaoSuperior}
					bind:espacamentoInferior={espacamentoDescricaoInferior}  />
 </Jumbotron></Collapse>
 
 
  {/if}       
		  </div>
          <div class="col-12 text-center">
		  {#if innerWidth<innerHeight || innerWidth<=limite}
              <Button  color="warning"  size="block"  on:click ={(e)=>AbreAcord(2, e)} class="mb-3"> Área dos botões</Button>
{/if}
{#if tgs[2]}
<Collapse {isOpen}> 
<Jumbotron class="border border-warning">

<h3>Área dos botões</h3>
            <p>Escolha a cor da área dos botões</p>
			   <label class=""  for="corAreaBotao">Cor da área do  botão</label>
	         
			   <input class="form-control mb-2"  type="color" id="corAreaBotao"  bind:value={corAreaBotao} />
			  
			  
             <Avancado {tipoUsuario}   ExibirFonte=true bind:sombra1={sombraAreaBotao1}
			  bind:sombra2={sombraAreaBotao2}
			  bind:sombra3={sombraAreaBotao3}
			  bind:sombra4={sombraAreaBotao4}
			  bind:corSombra={corSombraAreaBotao}
			  bind:fonte={fonteBotao}
			  bind:tamanhoLetra={tamanhoLetraBotao}
			  bind:espacamentoSuperior={espacamentoAreaBotaoSuperior}
			  bind:espacamentoInferior={espacamentoAreaBotaoInferior}

             />

			 </Jumbotron>
            </Collapse>
{/if}
          </div>
          <div class="col-12 text-center">

		  {#if innerWidth<innerHeight || innerWidth<=limite}
              <Button color="danger"  size="block"  on:click ={(e)=>AbreAcord(3, e)} class="mb-3">Área do Rodapé</Button>
{/if}
{#if tgs[3]}
<Collapse {isOpen}> 
    <Jumbotron class="border border-danger">        
            <h3>Rodapé</h3>
            <p>Escolha a cor do texto e da área do rodapé</p>
			<p></p>
			    <label class=""  for="corAreaRodape">Cor da área do  rodapé</label>
	          
			    <input class="form-control" type="color" id="corAreaRodape"  bind:value={corRodape} />
			  <p></p>
			  <label class=""  for="corLetraRodape">Cor da letra do rodapé</label>
			  <input class="form-control" type="color" id="corLetraRodape"  bind:value={corLetraRodape} /><p></p>
			 <label class=""  for="textoRodape">texto rodapé (Apenas PRO)</label>
			  
			  {#if tipoUsuario=="PRO" || tipoUsuario=="MASTER"}
			  <textarea class="form-control"  id="textoRodape" bind:value={textoRodape} ></textarea>
			  {:else}
			  <textarea class="form-control"  disabled id="textoRodape" bind:value={textoRodape} ></textarea>
		
			  {/if}
			  <p></p>
			  
			  
			  </Jumbotron></Collapse>
			 
			 
			 
			  {/if}
			  
  
			 
	 </div>
         
        </div>
		  <p></p>
          <hr>
		  
		     <Button outline color="primary"  size="block"  on:click ={(e)=>AbreAcord(4, e)} class="mb-3"> Criar os botões</Button>

{#if tgs[4]}
<Collapse {isOpen}> 
 
<Jumbotron  >
<div class="container">


<div class="col-12 mt-4 mb-2 text-center">
        <div class="row text-center">
           
		    
            <h2 class="col-12">Criando os botões de links</h2>
          </div>
        </div>
		</div>
        <div class="row text-center">
          <div class="col-lg-3 col-12 text-center">
         
              <label for="NomeBotao">Nome do botão</label>
				<input class="form-control" type="text" id="NomeBotao" bind:value={botao} />
	 			<br>
         
            
          </div>
          <div class="col-lg-3 col-12">
            <label for="link">Inserir {tipoLink}</label>
				<input class="form-control"  type="text" id="link" bind:value={link} /> 
				
          </div>
		 
		  <br>
		  <div class="col-lg-2 col-12"> 
		 <label>Tipo de botão</label>
            <select class="form-control" bind:value={tipoLink}>
				<option  value="link"   > Link</option> 
				<option  value="telefone" >Telefone</option> 
				<option  value="whatsapp" >Whatsapp </option> 
				<option  value="email">email</option> 
				<option  value="insta">instagram</option> 
				<option  value="maps">Maps</option> 
				<option  value="uber">Uber</option> 
		  </select>
		  <br>
		  </div>
           <div class="col-lg-2 col-12"> 
		   <label class=""  for="corLetraBotao">Cor da letra</label>
	           <input class="form-control"  type="color" id="corLetraBotao"   bind:value={corLetraBotao} />
			 </div>
			  <div class="col-lg-2 col-12"> 
             	<label class=""  for="corBotao">Cor do botão</label>
	            <input  class="form-control"  type="color" id="corBotao"  bind:value={corBotao} /><p></p>
  </div>
		   <Card class="col-12 mt-2 mb-2" >
				{#if tipoLink=="link"}
				Insira um link acima. Caso não começe com http:// ou https:// será acrescentado o prefixo http://
				{:else if tipoLink=="telefone"}
				Insira um telefone acima com ddd (apenas número ex. 0819999911111)

				{:else if tipoLink=="whatsapp"}
				Insira um telefone acima com ddd (apenas número ex. 0819999911111), se preferir colcocar um link para whatsapp escolha a opção link
				{:else if tipoLink=="email"}
				Insira um email acima ex seu_nome@operadora.com.br
				{:else if tipoLink=="insta"}
				Insira um Instagram no formato @+nome ex. @linkagenda.  Se preferir colocar um link para Instagram, escolha a opção link.
				{:else if tipoLink=="maps"}
				Insira as coordenadas decimais no formato latitude, longitude . Ex. -7.219891,-35.8661268.  Se preferir colocar um link para o google maps, escolha a opção link.
				{:else if tipoLink=="uber"}
				Insira as coordenadas decimais no formato latitude, longitude . Ex. -7.219891,-35.8661268.  Se preferir colocar um link para o Uber, escolha a opção link.
			
				{/if}
				</Card>
      <br>
      <br>
	  <Avancado 
	  {tipoUsuario}  exibirFonte=false   apenasUmEspacamento=true bind:sombra1={sombraBotao1}
					bind:sombra2={sombraBotao2}
					bind:sombra3={sombraBotao3}
					bind:sombra4={sombraBotao4}
					bind:corSombra={corSombraBotao}
					bind:espacamentoSuperior={espacamentoBotaoSuperior}
					bind:espacamentoInferior={espacamentoBotaoInferior}  />
        <div class="container col-12 text-center">
          <div class="row col-12">
            
				<ul>
				
				
				
				</ul>
				<div class="col-12 flex-nowrap">
					
						<button class="col-lg-2   col-12 m-2 btn btn-success " on:click|preventDefault={()=>fazerBotao(0)}>Adicionar no final</button>	
						<button class="col-lg-2  col-12 m-2 btn btn-success " on:click|preventDefault={()=>fazerBotao(1)}>Adicionar no Início</button>	
						<button class="col-lg-2  col-12 m-2 btn btn-danger "  on:click|preventDefault={ApagarPrimeiro}>Apagar primeiro</button>
						<button class="col-lg-2  col-12 m-2 btn btn-danger " on:click|preventDefault={ApagarUltimo}>Apagar o último</button>
			
					
				</div>

			
				
				            
           
          </div>
	<br>
        </div>
      </Jumbotron>
	   </Collapse>
{/if}
         
      
        <div class="row">
          <div class="col-12">
		     <Button  outline color="primary"  size="block"  on:click ={(e)=>AbreAcord(5, e)} class="mb-3"> Personalizar link e salvar</Button>
{#if tgs[5]}
<Collapse {isOpen}> 	
<Jumbotron>  
            <h2>Escolher link</h2>
			{#if tipoUsuario=="BASICO" || tipoUsuario=="EXPIRADO"}
			<p> (Para Planos PLUS e PRO)</p>
			<button class="btn btn-primary" on:click|preventDefault={(e)=>ChamarTela("planos")}>Mudar de plano</button> <p></p>
			{/if}

			 en-curta.me/_ 
			{#if tipoUsuario!="BASICO" && tipoUsuario!="EXPIRADO"}
			 <input id="linkPersonalizado" class="form-control" name="linkPersonalizado" bind:value={linkPersonalizado} on:input={teste}  placeholder="Link" >
            {:else}
             <input id="linkPersonalizado" class="form-control" name="linkPersonalizado" bind:value={linkAleatorio} placeholder="Link" readonly >
         
			{/if}
	   
	     {#if (habilitaSalvar && quantidadeBotoes>0) || (edit && linkPersonalizado==linkPersonalizadoRetorno && quantidadeBotoes>0)}
		 <p></p>
		      <input type="hidden" value="{quantidadeBotoes}" name="quantidade"/>
			  {#if tipoUsuario!="BASICO" && tipoUsuario!="EXPIRADO"}
				<input type="hidden" value="modelo2" name="modelo"/>
			
			  {:else}
				<input type="hidden" value="modelo1" name="modelo"/>
			  {/if}
		      
			  <button class="form-control" type="submit" name="submit">Salvar</button> 
            
		 {:else if quantidadeBotoes==0 }
<p></p> 

 {:else}


		  <p>link não disponível</p>
		 {/if}
		 </Jumbotron>
		 </Collapse>
		 {/if}
		  </div>
        </div>


     
	<hr>
	<h2>Visualize o resultado abaixo</h2>
	<hr> 
 
	
	
	<Microsite {tamanhoLetraDescricao}  {fonteDescricao} {sombraLogo1}  {sombraLogo2} {sombraLogo3}  {sombraLogo4} {corSombraLogo} 
	{sombraDescricao1} {sombraDescricao2} {sombraDescricao3} {sombraDescricao4} {corSombraDescricao}
	{espacamentoDescricaoSuperior} {espacamentoDescricaoInferior}
	 larguraMaxima={larguraMaximaLogoAplicada} logo="{url}" corCabecalho="{corCabecalho}" corLetraCabecalho="{corLetraCabecalho}" descricao="{descricaoBR}" link="{link}" botao="{botao}" corDescricao="{corDescricao}" corLetraDescricao="{corLetraDescricao}"/>
	 <p></p>
			
        <div class="container" >
          <div class="row">
            <div class="col-12 " style="background-color:{corAreaBotao}; box-shadow: {sombraAreaBotao1}px
			{sombraAreaBotao2}px {sombraAreaBotao3}px {sombraAreaBotao4}px {corSombraAreaBotao}; padding-top:{espacamentoAreaBotaoSuperior}px; 
			padding-bottom: {espacamentoAreaBotaoInferior}px; 
			
			">
			<p>&nbsp;</p>
				<p>&nbsp;</p>
			<!--	{#if !edit}--> 
				{#each ListaBotoes as item, i (item.id)}
				 
				<input type="hidden" name={"link"+(i+1)} value={item.itemLink}/>
				<input type="hidden" name={"botao"+(i+1)} value={item.itemBotao}/>
				<input type="hidden" name={"id_botao"+(i+1)} value={item.itemIdBotao}/>
				<input type="hidden" name={"ordem_botao"+(i+1)} value={i}/>
				
				<input type="hidden" name={"sombra_botao_1"} value={sombraBotao1}/>
				<input type="hidden" name={"sombra_botao_2"} value={sombraBotao2}/>
				<input type="hidden" name={"sombra_botao_3"} value={sombraBotao3}/>
				<input type="hidden" name={"sombra_botao_4"} value={sombraBotao4}/>
				<input type="hidden" name={"cor_sombra_botao"} value={corSombraBotao}/>
				<input type="hidden" name={"espacamento_botao_superior"} value={espacamentoBotaoSuperior}/>
				 
 
				<input type="hidden" name={"corLetraBotao"+(i+1)} value={item.itemCorLetraBotao}/>
				<input type="hidden" name={"corBotao"+(i+1)} value={item.itemCorBotao}/>
				 
				<Botoes 
				on:EditandoBotao={(e)=>EditaBotao(e,i)}
				on:ApagarBotao={(e)=>ApagarBotao(e,i)}
				on:SobeBotao={(e)=>SobeBotao(e,i)}
				on:DesceBotao={(e)=>DesceBotao(e,i)}
				posicao={i}

				id_botao={item.itemIdBotao}
				  {tipoLink}
				 {tamanhoLetraBotao}				
				 {sombraBotao1}
				 {sombraBotao2}
				 {sombraBotao3}
				 {sombraBotao4}			 	 
				 {corSombraBotao}
                 {espacamentoBotaoSuperior}
                 {espacamentoBotaoInferior}
				 {fonteBotao}
				 referencia={i+1} link={item.itemLink} botao={item.itemBotao}  corBotao = {item.itemCorBotao} corLetraBotao={item.itemCorLetraBotao}/>
				{/each}
            
				<p>&nbsp;</p>
				<p>&nbsp;</p>
			</div>
		</div>
	  </div> 
	    
	<!--passar os parametros-->
            <input type="hidden" name="corCabecalho" value={corCabecalho}/>
            <input type="hidden" name="descricao" value={descricaoBR}/>
            <input type="hidden" name="corDescricao" value={corDescricao}/>
            <input type="hidden" name="corLetraDescricao" value={corLetraDescricao}/>
            <input type="hidden" name="corAreaBotao" value={corAreaBotao}/>
            <input type="hidden" name="corAreaRodape" value={corRodape}/>
            <input type="hidden" name="corLetraRodape" value={corLetraRodape}/>
            <input type="hidden" name="inserido_por" value={login}/>
           
            <input type="hidden" name="largura_maxima_logo" value={larguraMaximaLogo}/>
            <input type="hidden" name="sombra_logo_1" value={sombraLogo1}/>
            <input type="hidden" name="sombra_logo_2" value={sombraLogo2}/>
            <input type="hidden" name="sombra_logo_3" value={sombraLogo3}/>
            <input type="hidden" name="sombra_logo_4" value={sombraLogo4}/>
            <input type="hidden" name="cor_sombra_logo" value={corSombraLogo}/> 
			
			<input type="hidden" name="sombra_descricao_1" value={sombraDescricao1}/>
            <input type="hidden" name="sombra_descricao_2" value={sombraDescricao2}/>
            <input type="hidden" name="sombra_descricao_3" value={sombraDescricao3}/>
            <input type="hidden" name="sombra_descricao_4" value={sombraDescricao4}/>
            <input type="hidden" name="cor_sombra_descricao" value={corSombraDescricao}/>

			<input type="hidden" name="espacamento_descricao_superior" value={espacamentoDescricaoSuperior}/>
			<input type="hidden" name="espacamento_descricao_inferior" value={espacamentoDescricaoInferior}/>


			<input type="hidden" name="espacamento_area_botao_superior" value={espacamentoAreaBotaoSuperior}/>
			<input type="hidden" name="espacamento_area_botao_inferior" value={espacamentoAreaBotaoInferior}/>
            <input type="hidden" name="espacamento_botao" value={espacamentoBotaoSuperior}/>
			


			<input type="hidden" name="sombra_area_botao_1" value={sombraAreaBotao1}/>
			<input type="hidden" name="sombra_area_botao_2" value={sombraAreaBotao2}/>
			<input type="hidden" name="sombra_area_botao_3" value={sombraAreaBotao3}/>
			<input type="hidden" name="sombra_area_botao_4" value={sombraAreaBotao4}/>
			<input type="hidden" name="cor_sombra_area_botao" value={corSombraAreaBotao}/>
			<input type="hidden" name="fonte_descricao" value={fonteDescricao}/>
			<input type="hidden" name="fonte_botao" value={fonteBotao}/>
			<input type="hidden" name="tamanho_letra_descricao" value={tamanhoLetraDescricao}/>
			<input type="hidden" name="tamanho_letra_botao" value={tamanhoLetraBotao}/>
		
			<input type="hidden" name="texto_rodape" value={textoRodape}/>
			{#if edit}
			  <input type="hidden" value="{linkPersonalizadoRetorno}" name="linkAntigo"/>
			  
		      <input type="hidden" value="{id_unico}" name="id_unico"/>
			  {/if}
           
			<Rodape {textoRodape} corAreaRodape={corRodape} corLetraRodape={corLetraRodape} />
		</form>	          
</main> 
 
<style>
   
   
	main {
		text-align: center;
		padding: 1em;
		
		margin: 100px auto;
	}
    .cinza{
		color:#666666;
	}
	h1 {
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	}

	.img-fundo{
		
		
		background-repeat: no-repeat;
		 background-position: center;
	}
	.sm{
		width:60px;
	}
	
</style>